const Mutations = Object.freeze({
	SET_FILES: 'dataImport/SET_FILES',
	SET_LOADING: 'dataImport/SET_LOADING',
	SET_ENTITIES: 'dataImport/SET_ENTITIES',
	SET_TEMPLATES: 'dataImport/SET_TEMPLATES',
	SET_FILES_INSERT: 'dataImport/SET_FILES_INSERT',
	SET_TOTAL_COUNT: 'dataImport/SET_TOTAL_COUNT',
});
export const Actions = Object.freeze({
	LOAD: 'dataImport/LOAD',
	LOAD_FILES: 'dataImport/LOAD_FILES',
	// LOAD_TEMPLATES: "dataImport/LOAD_TEMPLATES",
	LOAD_AVAILABLE_TEMPLATES: 'dataImport/LOAD_AVAILABLE_TEMPLATES',
	LOAD_ENTITIES: 'dataImport/LOAD_ENTITIES',
	INSERT: 'dataImport/INSERT',
	CLEAR: 'dataImport/CLEAR',
});
export const Getters = Object.freeze({
	GET_FILES: 'dataImport/FILES',
	GET_ENTITIES: 'dataImport/ENTITIES',
	GET_TEMPLATES: 'dataImport/TEMPLATES',
	GRID_LOADING: 'dataImport/GRID_LOADING',
	TOTAL_COUNT: 'dataImport/TOTAL_COUNT',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/importDataService';
import templates from './templates';
export default {
	state: {
		files: [],
		totalCount: 0,
		entities: [],
		dataImportTemplates: [],
		loading: false,
	},
	modules: {
		templates,
	},
	mutations: {
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_TEMPLATES](state, value) {
			state.dataImportTemplates = value;
		},
		[Mutations.SET_FILES_INSERT](state, item) {
			state.files.unshift(item);
		},
		[Mutations.SET_FILES](state, items) {
			state.files = items;
		},
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_FILES, []);
				commit(Mutations.SET_ENTITIES, []);
				commit(Mutations.SET_TEMPLATES, []);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD]({ dispatch }) {
			return Promise.all([
				dispatch(Actions.LOAD_ENTITIES),
				dispatch(Actions.LOAD_AVAILABLE_TEMPLATES),
			]);
		},
		[Actions.LOAD_FILES]({ commit, dispatch }, opts) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.getImportFiles(opts)
					.then((resp) => {
						commit(Mutations.SET_FILES, resp.data.Items);
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(Mutations.SET_LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},

		[Actions.LOAD_AVAILABLE_TEMPLATES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dataService
					.getAvailableTemplates()
					.then((resp) => {
						commit(Mutations.SET_TEMPLATES, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.LOAD_ENTITIES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dataService
					.getEntities()
					.then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.INSERT]({ dispatch, commit }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let formData = new FormData();
				formData.append('file', item.file);
				formData.append('item', JSON.stringify(item.importFile));
				dataService
					.insertFile(formData)
					.then((response) => {
						commit(Mutations.SET_FILES_INSERT, response.data);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.GRID_LOADING]: (state) => {
			return state.loading === true;
		},
		[Getters.GET_FILES]: (state) => {
			return JSON.parse(JSON.stringify(state.files));
		},
		[Getters.GET_ENTITIES]: (state) => {
			return JSON.parse(
				JSON.stringify(
					state.entities.sort((a, b) => (a.Name > b.Name ? 1 : -1))
				)
			);
		},
		[Getters.GET_TEMPLATES]: (state) => {
			return JSON.parse(
				JSON.stringify(
					state.dataImportTemplates.sort((a, b) =>
						a.Name > b.Name ? 1 : -1
					)
				)
			);
		},
		[Getters.TOTAL_COUNT]: (state) => {
			return state.totalCount;
		},
	},
};
